import { render } from "./CastMember.vue?vue&type=template&id=befc0096&scoped=true"
import script from "./CastMember.vue?vue&type=script&lang=js"
export * from "./CastMember.vue?vue&type=script&lang=js"

import "./CastMember.vue?vue&type=style&index=0&id=befc0096&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-befc0096"]])

export default __exports__